<template>
	<div>
		<div style="width: 90%;margin: 0 auto;">
			<el-form :inline="false" :model="openAnAccountForm" :rules="rules" class="demo-form-inline " ref="openAnAccountForm" label-width="100px">
				<div class="formOne">
					<el-form-item label="用户名" prop='user_name'>
						<el-input size="medium" clearable v-model="openAnAccountForm.user_name" placeholder="请输入用户名" maxlength="30">
						</el-input>
					</el-form-item>
					<el-form-item label="用户手机号" prop='mobile'>
						<el-input size="medium" clearable v-model="openAnAccountForm.mobile" placeholder="请输入用户手机号" maxlength="11">
						</el-input>
					</el-form-item>
					<el-form-item label="邀请码" prop="invite_code">
						<el-input size="medium" clearable v-model="openAnAccountForm.invite_code" placeholder="请输入邀请码" @change="initOption"  maxlength="11">
						</el-input>
					</el-form-item>
					<el-form-item label="邀请人">
						<el-input size="medium" disabled v-model="inviteUserInfo.name" placeholder="根据邀请码自动获取">
						</el-input>
					</el-form-item>
					<el-form-item label="邀请人身份">
						<el-input size="medium" disabled v-model="inviteUserInfo.role_name" placeholder="根据邀请码自动获取">
						</el-input>
					</el-form-item>
					<el-form-item label="用户身份" prop='role_code'>
						<el-select v-model="openAnAccountForm.role_code" placeholder="请选择用户身份" clearable>
							<el-option v-for="item in inviteUserInfo.role_list" :key="item.role_code" :label="item.role_name"
								:value="item.role_code">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button size="medium" type="primary" style="font-size: 12px;"
							@click="submitForm(openAnAccountForm)">确定注册</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: "userAccountOpening",
		data() {
			return {
				openAnAccountForm: {

				},
				inviteUserInfo: {},
				rules: {
				  user_name: [{
				    required: true,
				    message: '请输入用户名',
				    trigger: 'blur'
				  }],
				  mobile: [{
				    required: true,
				    message: '请输入用户手机号',
				    trigger: 'blur'
				  }],
				  invite_code: [{
				    required: true,
				    message: '请输入邀请码',
				    trigger: 'blur'
				  }],
				  role_code: [{
				    required: true,
				    message: '请选择用户身份',
				    trigger: 'change'
				  }],
				},
			}
		},
		created() {

		},
		methods: {
			//邀请码获取用户身份数据 
			initOption() {
				if(this.openAnAccountForm.invite_code){
					this.$api.post("/api/system/getInviteCodeInfo", {invite_code:this.openAnAccountForm.invite_code}, res => {
						if (res.status == 200) {
							this.inviteUserInfo = res.data;
						} else {
							this.$message.error(res.msg);
							this.inviteUserInfo = {};
							this.openAnAccountForm.role_id = null;
						}
					})
				}
			},
			//提交
			submitForm() {
			  this.$refs['openAnAccountForm'].validate((valid) => {
			    if (valid) {
			      this.$api.post("/api/system/adduserInfo", this.openAnAccountForm, res => {
			        if (res.status == 200) {
			          this.$message.success(res.msg);
			          this.openAnAccountForm = {};
					  this.inviteUserInfo = {};
			        } else {
			          this.$message.error(res.msg);
			        }
			      })
			    } else {
			      console.log('error submit!!');
			      return false;
			    }
			  });
			},


		}
	}
</script>
<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}

	.code {
		cursor: pointer;
	}

	.code:hover {
		color: #5111ee;
		text-decoration: underline;
	}

	/*::v-deep .is-leaf{*/
	/*  color: #000000;*/
	/*  font-weight: bold;*/
	/*  background-color: #e5e4e4;*/
	/*}*/
</style>
